import { CopyToClipboardButton } from '@library/components/buttons';
import type { FormattedNewWagerAttributes } from '@library/types/newWagers';
import { formattedNewWagerDetails } from '@bo-utils/newWagers';

export interface MemberEntryCardFooterProps {
  newWager: FormattedNewWagerAttributes;
}

export const MemberEntryCardFooter = ({
  newWager
}: MemberEntryCardFooterProps) => {
  const { newWagerCreatedDate } = formattedNewWagerDetails(newWager);

  return (
    <div
      className="border-soFresh-140 flex items-center justify-between border-t p-4"
      data-testid="member-entry-card-footer"
    >
      <div className="text-soClean-180 flex items-center justify-start">
        <span className="mr-1 text-sm leading-normal">{newWager.id}</span>
        <CopyToClipboardButton
          bannerMessage="Copied Entry ID to Clipboard"
          btnClassName="flex items-center"
          textCopied={newWager.id}
        />
      </div>
      <p className="text-soClean-180 text-sm">{newWagerCreatedDate}</p>
    </div>
  );
};
